import React from 'react';
import { formatDate, truncateText } from '../../utils/helpers';

const BlogCard = ({ blog, onReadMore }) => {
    return (
        <div 
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer overflow-hidden group"
            onClick={() => onReadMore(blog.id)}
        >
            <div className="p-6">
                {/* Blog Icon */}
                <div className="w-12 h-12 bg-gradient-to-r from-gradpath-green to-gradpath-dark rounded-lg flex items-center justify-center mb-4">
                    <i className="fas fa-newspaper text-white text-xl"></i>
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-gradpath-dark mb-2 line-clamp-2 group-hover:text-gradpath-green transition-colors">
                    {blog.title}
                </h3>
                
                {/* Meta Info */}
                <div className="flex flex-wrap gap-3 text-sm text-gray-500 mb-3">
                    <span className="inline-flex items-center gap-1">
                        <i className="fas fa-user text-gradpath-green text-xs"></i>
                        {blog.author}
                    </span>
                    <span className="inline-flex items-center gap-1">
                        <i className="fas fa-calendar-alt text-gradpath-green text-xs"></i>
                        {formatDate(blog.createdAt)}
                    </span>
                </div>
                
                {/* Tagline/Excerpt */}
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                    {truncateText(blog.tagline || blog.content?.substring(0, 150), 150)}
                </p>
                
                {/* Read More Button */}
                <button className="text-gradpath-green font-semibold text-sm hover:text-gradpath-dark transition-all inline-flex items-center gap-1 group-hover:gap-2">
                    Read More <i className="fas fa-arrow-right text-xs"></i>
                </button>
            </div>
        </div>
    );
};

export default BlogCard;